import { render } from "./video-item-editor.vue?vue&type=template&id=6e4f40b9"
import script from "./video-item-editor.vue?vue&type=script&lang=js"
export * from "./video-item-editor.vue?vue&type=script&lang=js"
script.render = render

export default script